import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>A Brief Portfolio</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/rockps.png'
              text='Rock, Paper, Scissors'
              label='Game'
              path='https://sirjanchawla.github.io/RockPaperScissors/'
            />
            <CardItem
              src='images/asteroids.jpg'
              text='"AstroFun"'
              label='Project'
              path='https://github.com/sirjanchawla/astrofun'
            />
            <CardItem
              src='images/git.png'
              text='YT video Fetcher'
              label='Project'
              path='https://github.com/sirjanchawla/YTD_fetcher'
            />
             <CardItem
              src='images/git.png'
              text='rect crasher'
              label='Game'
              path='https://sirjanchawla.github.io/'
            />
             <CardItem
              src='images/git.png'
              text='My other projects'
              label='Project'
              path='https://github.com/sirjanchawla'
            />
          </ul>
          
        </div>
      </div>
    </div>
  );
}

export default Cards;